module.exports = __webpack_public_path__ + "img/keepkey.4c666046.svg";